import { render, staticRenderFns } from "./vmsTemplate.vue?vue&type=template&id=06129c8f&scoped=true"
import script from "./vmsTemplate.vue?vue&type=script&lang=js"
export * from "./vmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./vmsTemplate.vue?vue&type=style&index=0&id=06129c8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06129c8f",
  null
  
)

export default component.exports